import { FREE_SIGNUP_CREDITS, formatSignupCreditsLabel } from '../../config/credits'

/** Guest demo entry — primary conversion from /marketplace ads. */
export const MARKETPLACE_DEMO_PATH = '/product-cards?mode=mp'

export const MARKETPLACE_SEO = {
  title: 'Карточки товаров для WB и Ozon — AI-студия KartinAi',
  description:
    'Сделайте карточки для маркетплейса из фото товара: шаблоны МП, набор из 3 в одном стиле, модель в одежде, оживление и видео 360. Откройте студию бесплатно.',
  path: '/marketplace',
  ogImage: '/landing/3.png',
}

export const MARKETPLACE_NAV = [
  { href: '#examples', label: 'Примеры' },
  { href: '#pain', label: 'Зачем' },
  { href: '#pricing', label: 'Тарифы' },
  { href: '#features', label: 'Возможности' },
  { href: '#faq', label: 'Вопросы' },
  { href: '#contacts', label: 'Контакты' },
] as const

export const MARKETPLACE_HERO = {
  badge: 'Для продавцов WB и Ozon',
  title: 'ИИ-карточки товаров для маркетплейсов',
  subtitle:
    'Загрузите фото — получите слайды под WB / Ozon: шаблоны, набор из 3, модель в одежде. Сразу откроется студия карточек.',
  trialBadge: `Режим просмотра без регистрации · ${formatSignupCreditsLabel(FREE_SIGNUP_CREDITS)} при входе для генерации`,
  primaryCta: 'Попробовать',
  secondaryCta: 'Смотреть примеры',
  previewSub: 'Карточка товара',
  previewPrompt: 'Главный слайд WB: фото товара, выгоды, единый стиль набора...',
}

export const MARKETPLACE_PAIN = [
  {
    title: 'Дизайнер дорого и долго',
    desc: 'Каждая новая позиция или сезон — снова бриф, правки и ожидание.',
  },
  {
    title: 'Слайды «пляшут» стилем',
    desc: 'Разный свет и шрифты на карточках режут доверие и CTR в выдаче.',
  },
  {
    title: 'Нужны обновления каждую неделю',
    desc: 'Акции, новые ракурсы и A/B — без очереди в студию.',
  },
] as const

export const MARKETPLACE_PRICING = {
  label: 'Тарифы',
  title: 'Начните бесплатно',
  desc: 'Сначала Free — масштабируйтесь, когда поток карточек вырастет.',
} as const

export const MARKETPLACE_FEATURES = [
  {
    title: 'Сделай карточку по готовому шаблону',
    desc: 'Готовые композиции под карточки маркетплейса — не с нуля в Figma.',
    media: '/landing/3.png',
    isVideo: false,
  },
  {
    title: 'Создавай пакетом в едином стиле',
    desc: 'Три слайда в одной палитре и типографике — единый look карточки.',
    media: '/landing/5.png',
    isVideo: false,
  },
  {
    title: 'Делай модные фотосессии одним кликом',
    desc: 'Fashion lookbook: модель надевает ваш товар с референс-фото — для карточки и рекламы.',
    media: '/landing/marketplace-lookbook.png',
    isVideo: false,
  },
  {
    title: 'Оживляй фото и делай видео 360',
    desc: 'Короткое видео товара и вращение — в том же разделе, когда понадобится.',
    media: '/landing/7.mp4',
    isVideo: true,
  },
] as const

export const MARKETPLACE_EXAMPLES = [
  {
    title: 'Главный слайд',
    desc: 'Товар в кадре, акценты выгод под выдачу МП.',
    media: '/landing/3.png',
    isVideo: false,
  },
  {
    title: 'Стиль «Графит»',
    desc: 'Тех-люкс: графит, сталь, крупный заголовок на карточке.',
    media: '/stile/pc-mp-graphite.png',
    isVideo: false,
  },
  {
    title: 'Модель в одежде',
    desc: 'Lookbook-кадр: модель в вашем товаре, студийный или lifestyle свет.',
    media: '/landing/generated-fd19377.png',
    isVideo: false,
  },
  {
    title: 'Оживление товара',
    desc: 'Лёгкое движение из одного фото.',
    media: '/landing/7.mp4',
    isVideo: true,
  },
  {
    title: 'Видео 360',
    desc: 'Вращение для карточки и рекламы.',
    media: '/landing/9.mp4',
    isVideo: true,
  },
  {
    title: 'Чистый объект',
    desc: 'Фон снят — готово к новому фону или слайду.',
    media: '/landing/6.png',
    isVideo: false,
  },
] as const

export const MARKETPLACE_FAQ = [
  {
    q: 'Нужна регистрация, чтобы посмотреть?',
    a: 'Нет. «Попробовать» открывает студию карточек в режиме просмотра. Генерация — после короткого входа.',
  },
  {
    q: 'Это только для Wildberries и Ozon?',
    a: 'Шаблоны и форматы заточены под карточки маркетплейсов. Результат можно скачать и использовать и на других площадках.',
  },
  {
    q: 'Можно сделать несколько слайдов в одном стиле?',
    a: 'Да — набор из 3: общие палитра и свет, разные кадры и тексты под одну карточку.',
  },
  {
    q: 'Сколько стоит старт?',
    a: `${formatSignupCreditsLabel(FREE_SIGNUP_CREDITS)} начисляются при регистрации. Дальше — по тарифам в разделе Баланс.`,
  },
] as const

export const MARKETPLACE_FINAL_CTA = {
  title: 'Откройте студию карточек',
  desc: 'Сразу попадёте в Карточки товаров — без дашборда и лишних шагов.',
  button: 'Попробовать',
}

export const MARKETPLACE_CONTACTS = {
  email: 'kartinai@pardmind.pro',
  vk: 'https://vk.com/kartinai',
  vkLabel: 'vk.com/kartinai',
  telegram: 'https://t.me/KartinaAi_official',
  telegramLabel: '@KartinaAi_official',
  title: 'На связи',
  titleRest: 'с командой KartinAI',
  desc: 'Вопросы по карточкам, тарифам и поддержке — пишите удобным способом.',
} as const

export const MARKETPLACE_LOGOS_STRIP =
  'Селлеры и менеджеры МП собирают карточки в KartinAi — быстрее, чем ждать дизайнера'
